export default __webpack_public_path__ + "static/media/puppyMaleLightBlue.721c58eb.jpg";